<template>
  <div class="edit-workgroup-member-dailog dialog col-block">
    <customForm
      :init="member"
      :alerts="alerts"
      :forms="formOptions['field1']"
      @change="(result, validate, errors) => formOnChange('field1', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '20px' }"></div>
    <customForm
      :init="member"
      :alerts="alerts"
      :forms="formOptions['field2']"
      @change="(result, validate, errors) => formOnChange('field2', result, validate, errors)"
    ></customForm>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateSendMember() : ''">
        <span>{{ member.user_id ? $t('COMMON.button.___update') : $t('COMMON.button.___add') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { getWorkgroupCheckMember } from '../../api'
import customForm from '../../components/tool/customForm'
import toastMethods from '../../mixins/toastMethods.vue'
import { workgroupRoleOptions } from '../../constants/global/data'

export default {
  components: {
    customForm
  },
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      members: [],
      member: {
        role: 'Member'
      },
      users: [],
      alerts: {},
      result: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    roleOptions () {
      const workgroupRoleMap = workgroupRoleOptions.reduce((map, option) => ({ ...map, [option.value]: option }), {})
      return this.param.editableRoles.map(role => {
        let option = workgroupRoleMap[role]
        return { title: this.$t(option.title), value: option.value }
      })
    },
    // static
    formOptions () {
      return {
        field1: [
          {
            title: this.member.user_id ? this.$t('DIALOG.editWorkgroupMember.form.title.___member') : this.$t('DIALOG.editWorkgroupMember.form.title.___newMember'),
            value: 'email',
            type: this.member.user_id ? 'text' : 'input',
            placeholder: () => this.$t('DIALOG.editWorkgroupMember.form.placeholder.___member'),
            wrap: true,
            textDisplay: value => value ? '<span>' + [this.member.first_name, this.member.last_name].filter(x => x).join(' ') + ' (</span><span style=color:#006ED6;>' + value + '</span>)' : value,
            validate: this.member.user_id ? '' : 'required'
          }
        ],
        field2: [
          {
            title: this.$t('DIALOG.editWorkgroupMember.form.title.___role'),
            value: 'role',
            type: 'select',
            options: this.roleOptions,
            placeholder: () => this.$t('DIALOG.editWorkgroupMember.form.placeholder.___role'),
            validate: 'required'
          }
        ]
      }
    }
  },
  created () {
    let member = this.param.member || this.member
    this.members = (this.param.members || []).filter(m => m.email !== member.email)
    this.member = member
  },
  methods: {
    formOnChange (field, result, validate, errors) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      // const isSubmit = !cols
      const validates = {
      }
      for (let col of cols || Object.keys(this.member)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateSendMember () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.sendMember()
      }
      this.onSubmit = false
    },
    async sendMember () {
      try {
        if (!this.members.some(member => this.result.email === member.email)) {
          let config = this.$ls.get('userInfo')
          let id = this.param.workgroup.id
          let params = {
            ...this.result
          }
          if (id) {
            params.workgroup_id = id
          }
          if (!this.member.user_id) {
            let response = await getWorkgroupCheckMember(params, config)
            let memberData = response.data.data
            memberData = {
              ...memberData,
              user_id: memberData.id
            }
            this.$emit('changeModal', {}, memberData)
          } else {
            let memberData = {
              ...this.member,
              ...this.result
            }
            this.$emit('changeModal', {}, memberData)
          }
        } else {
          throw new Error(this.$t('COMMON.toast.___workgroupMemberExist'))
        }
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editWorkgroupMember.vue